export const fieldsByComponent: { [key: string]: any[] } = {
    "1": [ // IDWH DOLPHIN
      { name: 'item', label: 'Items of Works', editable: false, group: null, superGroup: null, rowspan: 3 },
      { name: 'itemDD', label: 'item Name', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 }, 
      { name: 'quantity', label: 'Quantity', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      { name: 'unitDD', label: 'Unit', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 },
      { name: 'unitCost', label: 'Rate per Unit', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      { name: 'amountRequired', label: 'Amount Required (INR)',editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
    // { name: 'location', label: 'Location', editable: true, type: 'text', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
    // { name: 'gpsDD1', label: 'Latitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
    // { name: 'gpsMM1', label: 'Latitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
    // { name: 'gpsSS1', label: 'Latitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
    // { name: 'gpsDD2', label: 'Longitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
    // { name: 'gpsMM2', label: 'Longitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
    // { name: 'gpsSS2', label: 'Longitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
    //  { name: 'site', label: 'Site specific Justification', editable: true, type: 'text', group: null, superGroup: null, rowspan: 3 }
    ],
    "2": [ // IDWH CROCODILE
      { name: 'item', label: 'Items of Works', editable: false, group: null, superGroup: null, rowspan: 3 },
      { name: 'itemDD', label: 'item Name', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 },
      { name: 'quantity', label: 'Quantity', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      { name: 'unitDD', label: 'Unit', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 },
      { name: 'unitCost', label: 'Rate per Unit', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      { name: 'amountRequired', label: 'Amount Required (INR)', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      // { name: 'location', label: 'Location', editable: true, type: 'text', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsDD1', label: 'Latitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsMM1', label: 'Latitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsSS1', label: 'Latitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsDD2', label: 'Longitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsMM2', label: 'Longitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsSS2', label: 'Longitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      //{ name: 'site', label: 'Site specific Justification', editable: true, type: 'text', group: null, superGroup: null, rowspan: 3 }
    ],
    "3": [ // IDWH BLACKBUCK
      { name: 'item', label: 'Items of Works', editable: false, group: null, superGroup: null, rowspan: 3 },
      { name: 'itemDD', label: 'item Name', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 },
      { name: 'quantity', label: 'Quantity', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      { name: 'unitDD', label: 'Unit', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 },
      { name: 'unitCost', label: 'Rate per Unit', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      { name: 'amountRequired', label: 'Amount Required  (INR)', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      // { name: 'location', label: 'Location', editable: true, type: 'text', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsDD1', label: 'Latitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsMM1', label: 'Latitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsSS1', label: 'Latitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsDD2', label: 'Longitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsMM2', label: 'Longitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsSS2', label: 'Longitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
     // { name: 'site', label: 'Site specific Justification', editable: true, type: 'text', group: null, superGroup: null, rowspan: 3 }
    ],
    "4": [ // IDWH TURTLE
      { name: 'item', label: 'Items of Works', editable: false, group: null, superGroup: null, rowspan: 3 },
      { name: 'itemDD', label: 'item Name', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 },
      { name: 'quantity', label: 'Quantity', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      { name: 'unitDD', label: 'Unit', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 },
      { name: 'unitCost', label: 'Rate per Unit', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      { name: 'amountRequired', label: 'Amount Required  (INR)', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      // { name: 'location', label: 'Location', editable: true, type: 'text', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      //  { name: 'gpsDD1', label: 'Latitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsMM1', label: 'Latitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsSS1', label: 'Latitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsDD2', label: 'Longitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsMM2', label: 'Longitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsSS2', label: 'Longitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
     // { name: 'site', label: 'Site specific Justification', editable: true, type: 'text', group: null, superGroup: null, rowspan: 3 }
    ],
    "5": [ // IDWH SANCTUARY 
      { name: 'item', label: 'Item of Expenditure', editable: false, group: null, superGroup: null, rowspan: 3 },
      { name: 'itemDD', label: 'item Name', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 },
      { name: 'paraDetails', label: 'Para No. of the Management Plan which specializes this item', editable: true, type: 'text', group: null, superGroup: null, rowspan: 3 },
      { name: 'quantity', label: 'Quantity', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      { name: 'unitDD', label: 'Unit', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 },
      { name: 'unitCost', label: 'Rate per Unit', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      { name: 'amountRequired', label: 'Amount Required  (INR)', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      // { name: 'location', label: 'Location', editable: true, type: 'text', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      //  { name: 'gpsDD1', label: 'Latitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsMM1', label: 'Latitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsSS1', label: 'Latitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsDD2', label: 'Longitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsMM2', label: 'Longitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsSS2', label: 'Longitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
     // { name: 'site', label: 'Site specific Justification', editable: true, type: 'text', group: null, superGroup: null, rowspan: 3 }
    ],
    "10": [ // IDWH NATIONALPARK
      { name: 'item', label: 'Item of Expenditure', editable: false, group: null, superGroup: null, rowspan: 3 },
      { name: 'itemDD', label: 'item Name', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 },
      { name: 'paraDetails', label: 'Para No. of the Management Plan which specializes this item', editable: true, type: 'text', group: null, superGroup: null, rowspan: 3 },
      { name: 'quantity', label: 'Quantity', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      { name: 'unitDD', label: 'Unit', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 },
      { name: 'unitCost', label: 'Rate per Unit', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      { name: 'amountRequired', label: 'Amount Required  (INR)', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      // { name: 'location', label: 'Location', editable: true, type: 'text', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      //  { name: 'gpsDD1', label: 'Latitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsMM1', label: 'Latitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsSS1', label: 'Latitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsDD2', label: 'Longitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsMM2', label: 'Longitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsSS2', label: 'Longitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
     // { name: 'site', label: 'Site specific Justification', editable: true, type: 'text', group: null, superGroup: null, rowspan: 3 }
    ],
    "11": [ // IDWH Conservation Reserve
      { name: 'item', label: 'Item of Expenditure', editable: false, group: null, superGroup: null, rowspan: 3 },
      { name: 'itemDD', label: 'item Name', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 },
      { name: 'paraDetails', label: 'Para of Management Plan / Biodiversity Conservation Plan / Recovery Plan which specifies this item', editable: true, type: 'text', group: null, superGroup: null, rowspan: 3 },
      { name: 'quantity', label: 'Quantity', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      { name: 'unitDD', label: 'Unit', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 },
      { name: 'unitCost', label: 'Rate per Unit', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      { name: 'amountRequired', label: 'Amount Required  (INR)', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      // { name: 'location', label: 'Location', editable: true, type: 'text', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      //  { name: 'gpsDD1', label: 'Latitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsMM1', label: 'Latitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsSS1', label: 'Latitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsDD2', label: 'Longitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsMM2', label: 'Longitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsSS2', label: 'Longitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
     // { name: 'site', label: 'Site specific Justification', editable: true, type: 'text', group: null, superGroup: null, rowspan: 3 }
    ],
    "6": [ // 3590- PROJECT TIGER
        { name: 'item', label: 'Items of Works', editable: false, group: null, superGroup: null, rowspan: 3 },
        { name: 'itemDD', label: 'item Name', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 },
        { name: 'paraNoTCP', label: 'Para No. TCP', editable: true, type: 'text', group: null, superGroup: null, rowspan: 3 },
        { name: 'paraNoCSS', label: 'Para No. CSS PT Guidelines', editable: true, type: 'text', group: null, superGroup: null, rowspan: 3 },
        // Previous Year - Location with Geo-coordinates
        // { name: 'prev_location_division', label: 'Location/Division (Previous Year)', editable: true, type: 'text', group: 'Location with Geo-coordinates', superGroup: 'Previous Year Details', rowspan: 2 },
        // { name: 'prev_dd', label: 'Latitude DD (Previous Year)', editable: true, type: 'number', group: 'Location with Geo-coordinates', superGroup: 'Previous Year Details', rowspan: 2 },
        // { name: 'prev_mm', label: 'Latitude MM (Previous Year)', editable: true, type: 'number', group: 'Location with Geo-coordinates', superGroup: 'Previous Year Details', rowspan: 2 },
        // { name: 'prev_ss', label: 'Latitude SS (Previous Year)', editable: true, type: 'number', group: 'Location with Geo-coordinates', superGroup: 'Previous Year Details', rowspan: 2 },
        // { name: 'prev_dd2', label: 'Longitude DD (Previous Year)', editable: true, type: 'number', group: 'Location with Geo-coordinates', superGroup: 'Previous Year Details', rowspan: 2 },
        // { name: 'prev_mm2', label: 'Longitude MM (Previous Year)', editable: true, type: 'number', group: 'Location with Geo-coordinates', superGroup: 'Previous Year Details', rowspan: 2 },
        // { name: 'prev_ss2', label: 'Longitude SS (Previous Year)', editable: true, type: 'number', group: 'Location with Geo-coordinates', superGroup: 'Previous Year Details', rowspan: 2 },
        // Previous Year - Physical
        { name: 'physicalTargetPrev', label: 'Physical Target (Previous Year)', editable: true, type: 'number', group: 'Physical', superGroup: 'Previous Year Details', rowspan: 2 },
       { name: 'unitPrev', label: 'Unit (Previous Year)', editable: true,type:'dropdown', group: 'Physical', superGroup: 'Previous Year Details', rowspan: 2 },

        { name: 'physicalAchievementPrev', label: 'Physical Achievement (Previous Year)', editable: true, type: 'number', group: 'Physical', superGroup: 'Previous Year Details', rowspan: 2 },
        // Previous Year - Financial
        { name: 'financialTargetPrev', label: 'Financial Target (INR) (Previous Year)', editable: true, type: 'number', group: 'Financial', superGroup: 'Previous Year Details', rowspan: 2 },
        { name: 'financialAchievementPrev', label: 'Financial Achievement (INR) (Previous Year)', editable: true, type: 'number', group: 'Financial', superGroup: 'Previous Year Details', rowspan: 2 },
        // Current Year - Location with Geo-coordinates
        // { name: 'curr_location_division', label: 'Location/Division (Current Year)', editable: true, type: 'text', group: 'Location with Geo-coordinates', superGroup: 'Current Year Proposal', rowspan: 2 },
        // { name: 'curr_dd', label: 'Latitude DD (Current Year)', editable: true, type: 'number', group: 'Location with Geo-coordinates', superGroup: 'Current Year Proposal', rowspan: 2 },
        // { name: 'curr_mm', label: 'Latitude MM (Current Year)', editable: true, type: 'number', group: 'Location with Geo-coordinates', superGroup: 'Current Year Proposal', rowspan: 2 },
        // { name: 'curr_ss', label: 'Latitude SS (Current Year)', editable: true, type: 'number', group: 'Location with Geo-coordinates', superGroup: 'Current Year Proposal', rowspan: 2 },
        // { name: 'curr_dd2', label: 'Longitude DD (Current Year)', editable: true, type: 'number', group: 'Location with Geo-coordinates', superGroup: 'Current Year Proposal', rowspan: 2 },
        // { name: 'curr_mm2', label: 'Longitude MM (Current Year)', editable: true, type: 'number', group: 'Location with Geo-coordinates', superGroup: 'Current Year Proposal', rowspan: 2 },
        // { name: 'curr_ss2', label: 'Longitude SS (Current Year)', editable: true, type: 'number', group: 'Location with Geo-coordinates', superGroup: 'Current Year Proposal', rowspan: 2 },
        // Current Year - Proposal
        { name: 'physicalTargetCurr', label: 'Physical Target (Current Year prop.)', editable: true, type: 'number', group: 'Physical', superGroup: 'Current Year Proposal', rowspan: 2 },
        { name: 'unitCurr', label: 'Unit (Current Year prop.)', editable: true,type:'dropdown', group: 'Physical', superGroup: 'Current Year Proposal', rowspan: 2 },
        { name: 'unitCostCurr', label: 'Unit Cost (Current Year prop.)', editable: true, type: 'number', group: 'Physical', superGroup: 'Current Year Proposal', rowspan: 2 },
        { name: 'financialTargetCurr', label: 'Financial Target (INR) (Current Year prop.)', editable: true, type: 'number', group: 'Financial', superGroup: 'Current Year Proposal', rowspan: 2 },
     ],
    "7": [ // 0361- ELEPHANT MANAGEMENT PROJECT
      { name: 'item', label: 'Items of Works', editable: false, group: null, superGroup: null, rowspan: 3 },
      { name: 'itemDD', label: 'item Name', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 },
      { name: 'unitKms', label: 'Unit / Kms.', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      // { name: 'location', label: 'Location', editable: true, type: 'text', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsDD1', label: 'Latitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsMM1', label: 'Latitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsSS1', label: 'Latitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsDD2', label: 'Longitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsMM2', label: 'Longitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsSS2', label: 'Longitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      { name: 'amountINR', label: 'Amount  (INR)', editable: true, type: 'number', rowspan: 3 }
   ],
    "13": [ // Wildlife Protection And Conservation Measure (3128)
      { name: 'item', label: 'Item of Work', editable: false, group: null, superGroup: null, rowspan: 3 },
      { name: 'itemDD', label: 'item Name', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 },
      { name: 'physicalTarget', label: 'Physical Target', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      { name: 'unitDD', label: 'Unit', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 },
      { name: 'financialTarget', label: 'Financial Target  (INR)', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      // { name: 'location', label: 'Location', editable: true, type: 'text', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsDD1', label: 'Latitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsMM1', label: 'Latitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsSS1', label: 'Latitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsDD2', label: 'Longitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsMM2', label: 'Longitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsSS2', label: 'Longitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 }
    ],
    "14": [ // Management of Elephant and Corridor (3173)
      { name: 'item', label: 'Item of Work', editable: false, group: null, superGroup: null, rowspan: 3 },
      { name: 'itemDD', label: 'item Name', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 },
       { name: 'physicalTarget', label: 'Physical Target', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
       { name: 'unitDD', label: 'Unit', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 },
      { name: 'financialTarget', label: 'Financial Target  (INR)', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      // { name: 'location', label: 'Location', editable: true, type: 'text', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsDD1', label: 'Latitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsMM1', label: 'Latitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsSS1', label: 'Latitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsDD2', label: 'Longitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsMM2', label: 'Longitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsSS2', label: 'Longitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 }
    ],
    "8": [ // REGIONAL WILDLIFE  MANAGEMENT PLAN (RWLMP)
      { name: 'item', label: 'Item of Work', editable: false, group: null, superGroup: null, rowspan: 3 },
      { name: 'itemDD', label: 'item Name', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 },
       { name: 'physicalTarget', label: 'Physical Target', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
       { name: 'unitDD', label: 'Unit', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 },
      { name: 'financialTarget', label: 'Financial Target  (INR)', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      // { name: 'location', label: 'Location', editable: true, type: 'text', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsDD1', label: 'Latitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsMM1', label: 'Latitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsSS1', label: 'Latitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsDD2', label: 'Longitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsMM2', label: 'Longitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsSS2', label: 'Longitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 }
    ],
    "9": [ // SITE-SPECIFIC WILDLIFE CONSERVATION PLAN  (SSWLCP)
      { name: 'item', label: 'Item of Work', editable: false, group: null, superGroup: null, rowspan: 3 },
      { name: 'itemDD', label: 'item Name', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 },
       { name: 'physicalTarget', label: 'Physical Target', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
       { name: 'unitDD', label: 'Unit', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 },
      { name: 'financialTarget', label: 'Financial Target  (INR)', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      // { name: 'location', label: 'Location', editable: true, type: 'text', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsDD1', label: 'Latitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsMM1', label: 'Latitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsSS1', label: 'Latitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsDD2', label: 'Longitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsMM2', label: 'Longitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsSS2', label: 'Longitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 }
    ],
    "12": [ // NPV
      { name: 'item', label: 'Item of Work', editable: false, group: null, superGroup: null, rowspan: 3 },
      { name: 'itemDD', label: 'item Name', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 },
       { name: 'physicalTarget', label: 'Physical Target', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
       { name: 'unitDD', label: 'Unit', editable: true,type:'dropdown', group: null, superGroup: null, rowspan: 3 },
      { name: 'financialTarget', label: 'Financial Target  (INR)', editable: true, type: 'number', group: null, superGroup: null, rowspan: 3 },
      // { name: 'location', label: 'Location', editable: true, type: 'text', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsDD1', label: 'Latitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsMM1', label: 'Latitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsSS1', label: 'Latitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsDD2', label: 'Longitude DD', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsMM2', label: 'Longitude MM', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 },
      // { name: 'gpsSS2', label: 'Longitude SS', editable: true, type: 'number', group: 'Location with GPS Coordinates', superGroup: null, rowspan: 2 }
    ]
  };
  export const unitList  : any =[
    {
    "id": 1,
    "name": "Hectare (Ha.)",
  },
   {
    "id": 2,
    "name": "Running KM",
  },
   {
    "id": 3,
    "name": "Numbers (Nos.)",
  }
];
  export const schemeLists  : any =[{
    "id": 2,
    "name": "Centrally Sponsored Schemes(CSS)",
    "reportName": null,
    "about": null
  }];
  export const componentLists   : any =[
    {
      "id": 1,
      "name": "IDWH DOLPHIN",
      "reportName": " Annual Plan of Operation under CSS-Development of Wildlife Habitats under Recovery Programme towards Protection and Conservation of Irrawaddy Dolphin in Odisha during 2025-26 (Rs. in lakh)",
      "about": null
    },
    {
      "id": 2,
      "name": "IDWH CROCODILE",
      "reportName": " Annual Plan of Operation towards Protection and Conservation of Saltwater (Estuarine) Crocodiles, Odisha under the component \"Protection of Wildlife outside Protected Areas\"-CSS-Development of Wildlife Habitat during 2025-26 (Rs. in lakh)",
      "about": null
    },
    {
      "id": 3,
      "name": "IDWH BLACKBUCK",
      "reportName": "Annual Plan of Operation in respect of Protection and Conservation of Blackbucks in Odisha under the Component \nOutside PAs-CSS-Development of Wildlife Habitats during 2025-26 (Rs. in lakh)",
      "about": null
    },
    {
      "id": 4,
      "name": "IDWH TURTLE",
      "reportName": "Annual Plan of Operation for Conservation of Olive Ridley Sea Turtles in Odisha under the component ‘Recovery programme for saving the Critically Endangered species CSS-Development of Wildlife Habitats during 2025-26 (Rs. in lakh)",
      "about": null
    },
    {
      "id": 5,
      "name": "IDWH SANCTUARY AND NATIONALPARK",
      "reportName": "ANNUAL PLAN OF OPERATION (APO) IN RESPECT OF ________________ UNDER CSS-DEVELOPMENT OF WILDLIFE HABITATS\n FOR THE YEAR 2025-26",
      "about": "(The financial part of the APO should be furnished in chronological manner as per the  given format and percentage of expenditure as specified under different components should maintained while submitting the proposal.)"
    },
    {
      "id": 6,
      "name": "PROJECT TIGER",
      "reportName": "Annual Plan of Operation under Centrally Sponsored Scheme-Project Tiger & Elephant for the year 2025-26:\n________ TIGER RESERVE, _____",
      "about": null
    },
    {
      "id": 7,
      "name": "PROJECT_ELEPHANT",
      "reportName": "Annual Plan of Operation (APO) under CSS-0361-Elephant Management Project for the year 2025-26.",
      "about": null
    }
  ];
  export const apoObject  : any =[{
    "schemeId": 2,
    "schemeName": "Centrally Sponsored Schemes(CSS)",
    "componentId": 1,
    "componentName": "IDWH DOLPHIN",
    "reportName": " Annual Plan of Operation under CSS-Development of Wildlife Habitats under Recovery Programme towards Protection and Conservation of Irrawaddy Dolphin in Odisha during 2025-26 (Rs. in lakh)",
    "about": null,
    "formId": null,
    "creationDate": null,
    "taskList": [
      {
        "mapId": 6,
        "taskId": 2,
        "taskName": "ANTI POACHING & INFRASTRUCTURE DEVELOPMENT",
        "parentId": 0,
        "apoValueResponse": null,
        "subTaskList": [
          {
            "mapId": 5,
            "taskId": 6,
            "taskName": "Engagement of Dolphin Protection squad and mobility of staff by hiring Vehicles / Boats for Dolphin Conservation through out the year",
            "parentId": 2,
            "apoValueResponse": null,
            "subTaskList": []
          },
          {
            "mapId": 4,
            "taskId": 7,
            "taskName": "Wages to Boatman & Maintenance of Mechanized Boats",
            "parentId": 2,
            "apoValueResponse": null,
            "subTaskList": []
          },
          {
            "mapId": 3,
            "taskId": 8,
            "taskName": "Cost towards Binoculars, Cameras and other personal gears",
            "parentId": 2,
            "apoValueResponse": null,
            "subTaskList": []
          },
          {
            "mapId": 2,
            "taskId": 9,
            "taskName": "Maintenance of computer & recurring expenses of consumable articles",
            "parentId": 2,
            "apoValueResponse": null,
            "subTaskList": []
          }
        ]
      },
      {
        "mapId": 7,
        "taskId": 3,
        "taskName": "MANAGEMENT PLANNING & CAPACITY BUILDING",
        "parentId": 0,
        "apoValueResponse": null,
        "subTaskList": [
          {
            "mapId": 8,
            "taskId": 10,
            "taskName": "Strengthening Nature Education and Awareness",
            "parentId": 3,
            "apoValueResponse": null,
            "subTaskList": [
              {
                "mapId": 9,
                "taskId": 11,
                "taskName": "Support for Nature Education & Awareness to boat operators, local fishermen, students & local stakeholders",
                "parentId": 10,
                "apoValueResponse": null,
                "subTaskList": []
              },
              {
                "mapId": 11,
                "taskId": 12,
                "taskName": "Strengthening of Veterinary care",
                "parentId": 10,
                "apoValueResponse": null,
                "subTaskList": []
              },
              {
                "mapId": 12,
                "taskId": 13,
                "taskName": "Signages, Printing of brochures & IEC Materials, Flex, Banner and Documentation of Birds through Videography etc.",
                "parentId": 10,
                "apoValueResponse": null,
                "subTaskList": []
              },
              {
                "mapId": 10,
                "taskId": 14,
                "taskName": "Annual Status Survey of Dolphins",
                "parentId": 10,
                "apoValueResponse": null,
                "subTaskList": [
                  {
                    "mapId": 15,
                    "taskId": 16,
                    "taskName": "Training of staff on Rescue, Handling and Safe release of Dolphin",
                    "parentId": 14,
                    "apoValueResponse": null,
                    "subTaskList": []
                  },
                  {
                    "mapId": 16,
                    "taskId": 17,
                    "taskName": "Supporting programme for staff Development, community Empowerment and capacity building-Exposure visit to other PAs of the State",
                    "parentId": 14,
                    "apoValueResponse": null,
                    "subTaskList": []
                  }
                ]
              },
              {
                "mapId": 13,
                "taskId": 15,
                "taskName": "Study on carrying capacity of Dolphins/ Habitat preference and carrying capacity of tourist boat",
                "parentId": 10,
                "apoValueResponse": null,
                "subTaskList": []
              }
            ]
          }
        ]
      },
      {
        "mapId": 14,
        "taskId": 4,
        "taskName": "STAFF DEVELOPMENT AND CAPACITY BUILDING",
        "parentId": 0,
        "apoValueResponse": null,
        "subTaskList": []
      },
      {
        "mapId": 17,
        "taskId": 5,
        "taskName": "Monitoring and Evaluation",
        "parentId": 0,
        "apoValueResponse": null,
        "subTaskList": []
      }
    ]
  }];
  export const historyObj   : any ={
    "apoRequest": {
      "schemeId": 2,
      "schemeName": "Centrally Sponsored Schemes(CSS)",
      "componentId": 1,
      "componentName": "IDWH DOLPHIN",
      "reportName": " Annual Plan of Operation under CSS-Development of Wildlife Habitats under Recovery Programme towards Protection and Conservation of Irrawaddy Dolphin in Odisha during 2025-26 (Rs. in lakh)",
      "about": null,
      "formId": 1,
      "creationDate": null,
      "taskList": [
        {
          "mapId": 6,
          "taskId": 2,
          "taskName": "ANTI POACHING & INFRASTRUCTURE DEVELOPMENT",
          "parentId": 0,
          "apoValueResponse": {
            "quantity": null,
            "unitCost": null,
            "amountRequired": null,
            "location": null,
            "gpsdd1": null,
            "gpsmm1": null,
            "gpsss1": null,
            "gpsdd2": null,
            "gpsmm2": null,
            "gpsss2": null,
            "site": null
          },
          "subTaskList": [
            {
              "mapId": 5,
              "taskId": 6,
              "taskName": "Engagement of Dolphin Protection squad and mobility of staff by hiring Vehicles / Boats for Dolphin Conservation through out the year",
              "parentId": 2,
              "apoValueResponse": {
                "quantity": "10",
                "unitCost": "20",
                "amountRequired": "8000",
                "location": "test",
                "gpsdd1": "20",
                "gpsmm1": "50",
                "gpsss1": "56",
                "gpsdd2": "82",
                "gpsmm2": "50",
                "gpsss2": "50",
                "site": "site test"
              },
              "subTaskList": []
            },
            {
              "mapId": 4,
              "taskId": 7,
              "taskName": "Wages to Boatman & Maintenance of Mechanized Boats",
              "parentId": 2,
              "apoValueResponse": {
                "quantity": null,
                "unitCost": null,
                "amountRequired": null,
                "location": null,
                "gpsdd1": null,
                "gpsmm1": null,
                "gpsss1": null,
                "gpsdd2": null,
                "gpsmm2": null,
                "gpsss2": null,
                "site": null
              },
              "subTaskList": []
            },
            {
              "mapId": 3,
              "taskId": 8,
              "taskName": "Cost towards Binoculars, Cameras and other personal gears",
              "parentId": 2,
              "apoValueResponse": {
                "quantity": null,
                "unitCost": null,
                "amountRequired": null,
                "location": null,
                "gpsdd1": null,
                "gpsmm1": null,
                "gpsss1": null,
                "gpsdd2": null,
                "gpsmm2": null,
                "gpsss2": null,
                "site": null
              },
              "subTaskList": []
            },
            {
              "mapId": 2,
              "taskId": 9,
              "taskName": "Maintenance of computer & recurring expenses of consumable articles",
              "parentId": 2,
              "apoValueResponse": {
                "quantity": null,
                "unitCost": null,
                "amountRequired": null,
                "location": null,
                "gpsdd1": null,
                "gpsmm1": null,
                "gpsss1": null,
                "gpsdd2": null,
                "gpsmm2": null,
                "gpsss2": null,
                "site": null
              },
              "subTaskList": []
            }
          ]
        },
        {
          "mapId": 7,
          "taskId": 3,
          "taskName": "MANAGEMENT PLANNING & CAPACITY BUILDING",
          "parentId": 0,
          "apoValueResponse": {
            "quantity": null,
            "unitCost": null,
            "amountRequired": null,
            "location": null,
            "gpsdd1": null,
            "gpsmm1": null,
            "gpsss1": null,
            "gpsdd2": null,
            "gpsmm2": null,
            "gpsss2": null,
            "site": null
          },
          "subTaskList": [
            {
              "mapId": 8,
              "taskId": 10,
              "taskName": "Strengthening Nature Education and Awareness",
              "parentId": 3,
              "apoValueResponse": {
                "quantity": "400",
                "unitCost": "20",
                "amountRequired": "78956",
                "location": "Bhubaneswar",
                "gpsdd1": "20",
                "gpsmm1": "20",
                "gpsss1": "30",
                "gpsdd2": null,
                "gpsmm2": "20",
                "gpsss2": "85",
                "site": "BBSR"
              },
              "subTaskList": [
                {
                  "mapId": 9,
                  "taskId": 11,
                  "taskName": "Support for Nature Education & Awareness to boat operators, local fishermen, students & local stakeholders",
                  "parentId": 10,
                  "apoValueResponse": {
                    "quantity": null,
                    "unitCost": null,
                    "amountRequired": null,
                    "location": null,
                    "gpsdd1": null,
                    "gpsmm1": null,
                    "gpsss1": null,
                    "gpsdd2": null,
                    "gpsmm2": null,
                    "gpsss2": null,
                    "site": null
                  },
                  "subTaskList": []
                },
                {
                  "mapId": 11,
                  "taskId": 12,
                  "taskName": "Strengthening of Veterinary care",
                  "parentId": 10,
                  "apoValueResponse": {
                    "quantity": null,
                    "unitCost": null,
                    "amountRequired": null,
                    "location": null,
                    "gpsdd1": null,
                    "gpsmm1": null,
                    "gpsss1": null,
                    "gpsdd2": null,
                    "gpsmm2": null,
                    "gpsss2": null,
                    "site": null
                  },
                  "subTaskList": []
                },
                {
                  "mapId": 12,
                  "taskId": 13,
                  "taskName": "Signages, Printing of brochures & IEC Materials, Flex, Banner and Documentation of Birds through Videography etc.",
                  "parentId": 10,
                  "apoValueResponse": {
                    "quantity": null,
                    "unitCost": null,
                    "amountRequired": null,
                    "location": null,
                    "gpsdd1": null,
                    "gpsmm1": null,
                    "gpsss1": null,
                    "gpsdd2": null,
                    "gpsmm2": null,
                    "gpsss2": null,
                    "site": null
                  },
                  "subTaskList": []
                },
                {
                  "mapId": 10,
                  "taskId": 14,
                  "taskName": "Annual Status Survey of Dolphins",
                  "parentId": 10,
                  "apoValueResponse": {
                    "quantity": null,
                    "unitCost": null,
                    "amountRequired": null,
                    "location": null,
                    "gpsdd1": null,
                    "gpsmm1": null,
                    "gpsss1": null,
                    "gpsdd2": null,
                    "gpsmm2": null,
                    "gpsss2": null,
                    "site": null
                  },
                  "subTaskList": [
                    {
                      "mapId": 15,
                      "taskId": 16,
                      "taskName": "Training of staff on Rescue, Handling and Safe release of Dolphin",
                      "parentId": 14,
                      "apoValueResponse": {
                        "quantity": null,
                        "unitCost": null,
                        "amountRequired": null,
                        "location": null,
                        "gpsdd1": null,
                        "gpsmm1": null,
                        "gpsss1": null,
                        "gpsdd2": null,
                        "gpsmm2": null,
                        "gpsss2": null,
                        "site": null
                      },
                      "subTaskList": []
                    },
                    {
                      "mapId": 16,
                      "taskId": 17,
                      "taskName": "Supporting programme for staff Development, community Empowerment and capacity building-Exposure visit to other PAs of the State",
                      "parentId": 14,
                      "apoValueResponse": {
                        "quantity": null,
                        "unitCost": null,
                        "amountRequired": null,
                        "location": null,
                        "gpsdd1": null,
                        "gpsmm1": null,
                        "gpsss1": null,
                        "gpsdd2": null,
                        "gpsmm2": null,
                        "gpsss2": null,
                        "site": null
                      },
                      "subTaskList": []
                    }
                  ]
                },
                {
                  "mapId": 13,
                  "taskId": 15,
                  "taskName": "Study on carrying capacity of Dolphins/ Habitat preference and carrying capacity of tourist boat",
                  "parentId": 10,
                  "apoValueResponse": {
                    "quantity": null,
                    "unitCost": null,
                    "amountRequired": null,
                    "location": null,
                    "gpsdd1": null,
                    "gpsmm1": null,
                    "gpsss1": null,
                    "gpsdd2": null,
                    "gpsmm2": null,
                    "gpsss2": null,
                    "site": null
                  },
                  "subTaskList": []
                }
              ]
            }
          ]
        },
        {
          "mapId": 14,
          "taskId": 4,
          "taskName": "STAFF DEVELOPMENT AND CAPACITY BUILDING",
          "parentId": 0,
          "apoValueResponse": {
            "quantity": null,
            "unitCost": null,
            "amountRequired": null,
            "location": null,
            "gpsdd1": null,
            "gpsmm1": null,
            "gpsss1": null,
            "gpsdd2": null,
            "gpsmm2": null,
            "gpsss2": null,
            "site": null
          },
          "subTaskList": []
        },
        {
          "mapId": 17,
          "taskId": 5,
          "taskName": "Monitoring and Evaluation",
          "parentId": 0,
          "apoValueResponse": {
            "quantity": "400",
            "unitCost": "20",
            "amountRequired": "25688",
            "location": null,
            "gpsdd1": null,
            "gpsmm1": null,
            "gpsss1": null,
            "gpsdd2": null,
            "gpsmm2": null,
            "gpsss2": null,
            "site": null
          },
          "subTaskList": []
        }
      ]
    },
    "isReadOnly": true,
    "navigationId": 7
  };